var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProvider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 84",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.667 41.667c8.981 0 16.259-7.279 16.259-16.26 0-8.981-7.278-16.26-16.259-16.26-8.981 0-16.26 7.279-16.26 16.26 0 8.981 7.279 16.26 16.26 16.26zm-15.244 21.34a3.041 3.041 0 003.049 3.049 3.042 3.042 0 003.049-3.049 3.042 3.042 0 00-3.049-3.048 3.041 3.041 0 00-3.049 3.048zm27.438-17.199v6.224c4.637.94 8.13 5.056 8.13 9.959v5.297a2.04 2.04 0 01-1.638 1.995l-4.091.813a1.012 1.012 0 01-1.194-.801l-.394-1.994a1.006 1.006 0 01.801-1.194l2.451-.495v-3.621c0-7.977-12.194-8.269-12.194.242v3.391l2.451.496c.546.114.902.648.801 1.194l-.394 1.994a1.03 1.03 0 01-1.194.8l-3.964-.533a2.03 2.03 0 01-1.753-2.02v-5.564c0-4.903 3.494-9.006 8.13-9.959v-5.741c-.279.088-.559.139-.838.241a22.037 22.037 0 01-7.292 1.245c-2.553 0-5.005-.445-7.291-1.245a14.06 14.06 0 00-2.871-.661v10.366c2.934.876 5.081 3.569 5.081 6.783a7.118 7.118 0 01-7.113 7.114 7.118 7.118 0 01-7.114-7.114c0-3.214 2.147-5.907 5.081-6.783V46.024c-8.079 1.359-14.24 8.32-14.24 16.78v5.691a5.698 5.698 0 005.691 5.691H64.43a5.697 5.697 0 005.691-5.691v-5.691c0-9.146-7.215-16.552-16.26-16.996z",
    fill: "#1565c0",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvider);
export default __webpack_public_path__ + "static/media/provider.9225f71dd4fe08bf8b809611e324024f.svg";
export { ForwardRef as ReactComponent };